module.exports = __webpack_public_path__ + "img/twitch.bcb68047.svg";